import React from 'react';
import GxList from '../../gx/GxList';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import * as FxDat from '../../fx/FxDat';
import { useNav } from '../../hx/useNav';

import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreReferrer } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxReferrerList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const size = useWindowSize();
  const [storeReferrer, setStoreReferrer] = useSessionStorage('StoreReferrer', StoreReferrer);

  const r_list = React.useRef(null);

  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxReferrerList.addcol_txBranchId') === '1') };

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  React.useEffect(() => {
    clearStore('StoreReferrer', storeReferrer);
    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {

    if (row === null) {
      storeReferrer.inReferrer = null;
    } else {
      storeReferrer.inReferrer = row.original.inReferrer;
    }
    setStoreReferrer(storeReferrer);

    navTo("referrer-form");
  }

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inReferrer", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: "xx1", Header: trans('field.branch_id'), accessor: "txBranchId", highlight: true, width: '5%', show: hasColumnBranchId() });
        cols.push({ id: id++, Header: trans('field.referrer'), accessor: "txReferrer", highlight: true, width: '40%' });
        cols.push({ id: id++, Header: trans('field.contact'), accessor: "txContact", width: '20%' });
        cols.push({ id: id++, Header: trans('field.email'), accessor: "txEmail", width: '20%' });
        cols.push({ id: id++, Header: trans('field.mobile'), accessor: "txMobile", width: '10%' });
        cols.push({ id: id++, Header: trans('field.from'), accessor: row => ( FxTable.cellToLocalDate(row["dtFrom"]) ), width: '10%' });
      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: trans('field.referrer'), accessor: "txReferrer", highlight: true, width: '70%' });
        cols.push({ id: id++, Header: trans('field.mobile'), accessor: "txMobile", width: '30%' });
      }
      cols.push({ id: "A", Header: "inactive", accessor: row => FxDat.isExpired(row["dtTo"]), show: false });

    } catch(error) {
      FxLog.errorx('MxReferrerList.getTableColumns', error)
    }
    return cols;
  }

  const getTooltip = () => {
    let tip = `${trans('field.referrer')}`;
    if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
    return tip;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxReferrerList.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.referrers')}`}
        xref={r_list}
        tooltip={getTooltip()}
        fullscreen
        url="referrers"
        onOpenForm={openForm}
        refColors={ [ 'table_cell_color_gray|' + trans('field.inactive') ] }
        columns={getTableColumns()}
        optionalColumns={getTableOptionalCols()}
        onOptions={optionsSelected}
      />

    </div>
  );

}

export default MxReferrerList;